import { Activity } from 'lucide-react';

import Spinner from '@/components/Common/Spinner';
import { Stage } from '@/components/Stage/Stage';

import type { TriggerConditions } from '../../hooks';
import type { SignalAlertPreviewIssue } from '../../model';
import { SignalAlertPreviewTable } from './signal-alert-preview-table';

export type PreviewState =
  | { status: 'idle' }
  | { status: 'loading' }
  | { status: 'loaded'; data: SignalAlertPreviewIssue[] };

type SignalAlertPreviewPanelProps = {
  preview: PreviewState;
  duration: number;
  conditions: TriggerConditions;
};

export function SignalAlertPreviewPanel({
  preview,
  duration,
  conditions,
}: SignalAlertPreviewPanelProps) {
  return (
    <div className="flex h-full max-h-[800px] flex-1 flex-col overflow-hidden rounded-lg bg-[#F6F6F4] p-5">
      <Stage>
        <Stage.Scene
          status={preview.status === 'idle'}
          className="h-full"
          default
        >
          <div className="flex h-full flex-col items-center justify-center gap-3">
            <Activity className="text-muted-foreground size-8" />
            <p className="text-sm font-semibold">Preview matching issues</p>
            <p className="text-muted-foreground text-sm">
              Select a signal to see which issues match.
            </p>
          </div>
        </Stage.Scene>

        <Stage.Scene status={preview.status === 'loading'} className="h-full">
          <div className="flex h-full items-center justify-center">
            <Spinner size={24} />
          </div>
        </Stage.Scene>

        <Stage.Scene
          status={preview.status === 'loaded'}
          className="h-full"
          data={preview.status === 'loaded' ? preview.data : undefined}
        >
          {(data: SignalAlertPreviewIssue[]) => (
            <SignalAlertPreviewTable
              data={data}
              duration={duration}
              conditions={conditions}
            />
          )}
        </Stage.Scene>
      </Stage>
    </div>
  );
}
